<div class="cf-dlg">
  <div class="cf-dlg-header">
    <div class="cf-dlg-icon"><mat-icon>verified_user</mat-icon></div>
    <div class="vf-header-text">
      <h2 class="cf-dlg-title">Detalle VeriFactu</h2>
      <p class="cf-dlg-subtitle" *ngIf="data.number">{{ data.number }}</p>
    </div>
    <button mat-icon-button class="cf-dlg-close" (click)="closeDialog()" aria-label="Cerrar">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <ng-container *ngIf="!loading; else loadingTpl">
    <div class="cf-dlg-body">
      <div *ngIf="qrBase64" class="vf-qr">
        <img [src]="'data:image/png;base64,' + qrBase64" alt="QR VeriFactu" />
        <p class="vf-qr__label">Escanea el código para verificar en la AEAT</p>
      </div>

      <span class="cf-dlg-section__label">Eventos registrados</span>

      <ul *ngIf="events?.length; else emptyEvents" class="vf-events">
        <li *ngFor="let item of events; trackBy: trackByIndex" class="vf-events__item">
          <span class="vf-events__dot"></span>
          <span class="vf-events__text">
            {{ item.text }}
            <button type="button" class="vf-events__more" *ngIf="item.detail" (click)="toggleDetail(item)">
              {{ item.expanded ? 'Ocultar detalle' : 'Ver detalle técnico' }}
            </button>
            <span class="vf-events__detail" *ngIf="item.expanded">{{ item.detail }}</span>
          </span>
        </li>
      </ul>

      <ng-template #emptyEvents>
        <div class="vf-empty">
          <mat-icon>info</mat-icon>
          <span>{{ loadError ? 'No se pudieron cargar los datos de VeriFactu.' : 'No hay eventos registrados para este documento.' }}</span>
        </div>
      </ng-template>
    </div>

    <div class="cf-dlg-footer">
      <button mat-stroked-button class="cf-dlg-btn-secondary" (click)="closeDialog()">Cerrar</button>
    </div>
  </ng-container>

  <ng-template #loadingTpl>
    <app-loading-state message="Cargando datos de VeriFactu…"></app-loading-state>
  </ng-template>
</div>
